import type { ApiService, Logger } from "@packages/common";
import { API, LOGGER } from "@packages/common";
import { CONFIG, type Config } from "@packages/config";
import { Inject, Injectable } from "@webmotors/ioc";
import { VehicleTypeDTO } from "../search";
import type {
  RecommendationApiRequestDTO,
  RecommendationApiResponseDTO,
} from "./dtos";
import { RECOMMENDATION_SERVICE } from "./recommendation.types";
import { RecommendationTransformer } from "./transformer";

@Injectable(RECOMMENDATION_SERVICE)
export class RecommendationService {
  private readonly logger: Logger;

  constructor(
    @Inject(API)
    private readonly api: ApiService,
    @Inject(LOGGER)
    private readonly loggerFactory: Logger,
    @Inject(CONFIG)
    private readonly config: Config
  ) {
    this.logger = this.loggerFactory.create(RECOMMENDATION_SERVICE);
  }

  /**
   * Send a fetch request to the service
   *
   * @param params
   * @returns
   */
  async fetchItems(
    params: RecommendationApiRequestDTO
  ): Promise<RecommendationApiResponseDTO> {
    try {
      const response = await this.api.post<
        RecommendationApiRequestDTO,
        RecommendationApiResponseDTO
      >("/recommendation", params, {
        body: JSON.stringify(params),
      });

      const { success, message } = response;

      if (!success) {
        this.logger.error(`Recommendation failed: ${message}`);
      }

      const transformedResponse = RecommendationTransformer.transform(
        response,
        this.config.photoPath,
        this.config.baseURL,
        VehicleTypeDTO.CAR
      );

      return transformedResponse;
    } catch (error) {
      this.logger.error(`Recommendation failed: ${error}`);
      throw error;
    }
  }
}
